import { useQuery, useMutation } from '@tanstack/react-query'
import { addPaymentMethod as add, getPaymentMethod as getPaymentMethods } from '@/models/plans/apis'

// TODO: Add PaymentMethod type
type PaymentMethod = {
  id: string
}

export const usePaymentsQuery = () => {
  return useQuery({
    queryKey: ['payment-methods'],
    queryFn: async () => await getPaymentMethods(),
    refetchOnWindowFocus: false,
    staleTime: 60000 * 5
  })
}

const usePayments = () => {
  const {
    data: paymentInfoData,
    isLoading: paymentMethodsLoading,
    refetch: refetchPaymentMethods
  } = usePaymentsQuery()

  // Mutation for adding a payment method
  const addPaymentMethodMutation = useMutation({
    mutationFn: (values: PaymentMethod) => add(values),
    onSuccess: () => refetchPaymentMethods()
  })

  const addPaymentMethod = async (paymentMethodData: PaymentMethod) => {
    try {
      addPaymentMethodMutation.mutate(paymentMethodData)
    } catch (error) {
      console.error('Error adding payment method:', error)
    }
  }

  const modifyPaymentMethod = () => null

  return {
    paymentInfo: paymentInfoData ? paymentInfoData?.body : null,
    loading: paymentMethodsLoading,
    addPaymentMethod,
    modifyPaymentMethod
  }
}

export default usePayments
